<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Change Asset Status</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div  style="width: 124px;font-size: 14px;margin-right: 16px;color: black; text-align: initial;min-width: max-content;  display: flex;align-items: center;justify-content: flex-start;">
            <span style="width: 124px; display: block;font-size: 14px;margin-right: 16px;color: black; text-align: initial;min-width: max-content;">Implement Status</span>
            <select (change)="statusSelected($event.target.value)" style=" min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;color: #1D2F36; min-height: 40px; padding: 10px; min-width: 200px">
                <option value="" disabled selected>Select Status</option>
                <option *ngFor="let status of statusList" [value]="status.Id">{{status.Name}}</option>
            </select>
        </div>
      

        <div style="width: 124px; font-size: 14px;margin-right: 16px;color: black; text-align: initial;min-width: max-content;  display: flex;
        align-items: center;
        justify-content: flex-start;">
            <span style="width: 124px; display: block;font-size: 14px;margin-right: 16px;color: black; text-align: initial;min-width: max-content;">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()" matTooltip="{{ttDate}}" style="padding: 7px 16px;background: #E4EAF0;font-size: 14px;">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" 
            style="color: black;min-width: 200px; height: 40px;display: inline !important;background-color: #F4F7FA; min-height: 40px;padding: 10px;min-width: 245px;"
                  [max]="maxDateForAction" placeholder="Choose a date"
                   [(ngModel)]="eventDate" (ngModelChange)="dateChanged()"
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>

        <!-- <div class="input-container" *ngIf="showRepairerAndWorkshop">
            <span class="label">Repairer</span>
            <div>
                <select class="margin-right-8" [(ngModel)]="selectedRepairerId" (change)="repairerSelected($event.target.value)">
                    <option value="" disabled selected>Select Repairer</option>
                    <option *ngFor="let repairer of repairerList" [value]="repairer.Id">{{repairer.Name}}</option>
                </select>
                <button mat-icon-button (click)="addRepairer()">
                    <mat-icon>add</mat-icon>
                </button>
              
            </div>
        </div> -->
        <!-- <div class="input-container" *ngIf="showRepairerAndWorkshop">
            <span class="label">Workshop</span>
            <div>
                <select class="margin-right-8" [(ngModel)]="selectedWorkshopId" (change)="workshopSelected($event.target.value)">
                    <option value="" disabled selected>Select Workshop</option>
                    <option *ngIf="workshopList?.length > 0" value=""></option>
                    <option *ngFor="let workshop of workshopList" [value]="workshop.Id">{{workshop.Name}}</option>
                </select>
                <button mat-icon-button (click)="addWorkshop()" *ngIf="showAddWorkshop">
                    <mat-icon>add</mat-icon>
                </button>
                
            </div>
        </div> -->
        <div class="margin-bottom-16" style="margin-bottom: 16px;">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()"  style="resize: vertical;
        padding: 16px;
        background: #f4f7fa;
        font-size: 14px;
        border: none;
        height: auto;
        border: 1px solid transparent;
        width: 100%;"
                  placeholder="Enter a comment about why the implement status was changed. "
                  matTooltip="{{ttComment}}"></textarea>

               
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>